import { Controller } from "@hotwired/stimulus"

// CSP-safe replacement for onchange="this.form.submit()" filter selects.
export default class extends Controller {
  // Turbo-aware submit (was form.requestSubmit()).
  submit(e) {
    e.currentTarget.form?.requestSubmit()
  }

  // Full-page submit (was form.submit()) — used where the page relies on a
  // classic reload rather than a Turbo visit.
  native(e) {
    e.currentTarget.form?.submit()
  }
}
